<template>
    <section
        class="container grid grid-cols-2 items-center justify-between gap-2 sm:grid-cols-3 xl:flex">
        <label
            v-for="category in categories"
            :key="category.slug"
            :style="{ order: category.ordering }"
            class="group relative h-full w-full flex-1 grow cursor-pointer select-none overflow-hidden rounded-8 text-12/100 font-semibold transition-all duration-300 hover:bg-white/10 has-[:checked]:bg-accent xl:max-w-[13.75rem]">
            <div class="relative z-10 flex h-full min-h-15 w-full items-center">
                <Component
                    v-if="categoriesIcon[category.slug]"
                    :is="categoriesIcon[category.slug]"
                    class="size-15 shrink-0 max-md:hidden" />
                <div
                    v-html="category.name"
                    class="p-3" />
                <AtomIcon
                    name="close"
                    class="absolute right-1.5 top-1.5 size-3 opacity-0 transition-all duration-300 group-has-[:checked]:opacity-100" />
            </div>
            <input
                v-model="selectedCategories"
                type="checkbox"
                :value="category.id.toString()"
                class="sr-only absolute inset-0 z-20 size-full" />
            <div class="absolute inset-0 z-10 size-full">
                <div class="bg-noise"></div>
            </div>
        </label>
    </section>
</template>

<script setup lang="ts">
import type { Category } from '~/types/global.types'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import CategoryArendaVideo from '~/components/particles/category-multiselect/svg/CategoryArendaVideo.vue'
import CategoryArendaZvuka from '~/components/particles/category-multiselect/svg/CategoryArendaZvuka.vue'
import CategoryAudioguide from '~/components/particles/category-multiselect/svg/CategoryAudioguide.vue'
import CategoryCabine from '~/components/particles/category-multiselect/svg/CategoryCabine.vue'
import CategoryConferenceSystems from '~/components/particles/category-multiselect/svg/CategoryConferenceSystems.vue'
import CategoryEnvironment from '~/components/particles/category-multiselect/svg/CategoryEnvironment.vue'
import CategoryHeadphones from '~/components/particles/category-multiselect/svg/CategoryHeadphones.vue'
import CategoryRadioguide from '~/components/particles/category-multiselect/svg/CategoryRadioguide.vue'

const selectedCategories = defineModel({
    type: Array as PropType<number[]>,
})

defineProps({
    categories: {
        type: Array as PropType<Category[]>,
        default: () => [],
    },
})

const categoriesIcon: { [key: string]: object } = {
    radioguides: CategoryRadioguide,
    audioguides: CategoryAudioguide,
    interpretation: CategoryHeadphones,
    cabins: CategoryCabine,
    'conference-systems': CategoryConferenceSystems,
    'dostupnaia-sreda': CategoryEnvironment,
    'arenda-oborudovanie-dlya-sinhronnogo-perevoda': CategoryCabine,
    'arenda-konferents-system': CategoryConferenceSystems,
    'arenda-zvuka': CategoryArendaZvuka,
    'arenda-video': CategoryArendaVideo,
    'arenda-radioguides': CategoryRadioguide,
    'arenda-audioguides': CategoryAudioguide,
}
</script>
